const HOTEL_MAX_ROOMS = 9;
const HOTEL_MAX_CHILDREN = 8;
const HOTEL_MAX_TRAVELERS = 36;
function clampHotelOccupancy(occupancy) {
    const rooms = Math.min(Math.max(occupancy.rooms, 1), HOTEL_MAX_ROOMS);
    const children = Math.min(Math.max(occupancy.children, 0), HOTEL_MAX_CHILDREN);
    const adults = Math.min(Math.max(occupancy.adults, 1), HOTEL_MAX_TRAVELERS - children);
    return {
        rooms,
        adults,
        children
    };
}
export { HOTEL_MAX_CHILDREN, HOTEL_MAX_ROOMS, HOTEL_MAX_TRAVELERS, clampHotelOccupancy };
